import { BarChartProps } from "./types";
import { BarChartView } from "./view";
import { v4 as uuidv4 } from "uuid";

type ComponentType = React.FC<BarChartProps>;
export const BarChart: ComponentType = (props) => {
	const { data } = props;

	return (
		<BarChartView
			key={uuidv4()}
			labels={data.labels}
			series={data.series}
			title={data.title}
		/>
	);
};
